<app-tooltip-template label="Dimensions" *ngIf="params.dimensions?.length">
  <app-source [item]="dimension" [width]="15" *ngFor="let dimension of params.dimensions"></app-source>
</app-tooltip-template>
